import axios from 'axios';

// GET /users -> [{ id, firstName, lastName, email, ... }] (same read GodViewModal uses).
export async function getUsers() {
  try {
    const res = await axios.get('/users');
    return res.data.users || [];
  } catch (error) {
    console.error(error);
    return [];
  }
}
